import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import FeaturedTrails from "@/pages/FeaturedTrails";
import TrailDetail from "@/pages/TrailDetail";
import InterpretiveSignage from "@/pages/InterpretiveSignage";
import Services from "@/pages/Services";
import About from "@/pages/About";
import BecomeStoryteller from "@/pages/BecomeStoryteller";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/featured-trails" element={<FeaturedTrails />} />
            <Route path="/trails/:slug" element={<TrailDetail />} />
            <Route path="/interpretive-signage" element={<InterpretiveSignage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-it-works" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/become-a-storyteller" element={<BecomeStoryteller />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
